<div class="mytask-page">

  <!-- ── Page Header ─────────────────────────────── -->
  <div class="mytask-header">
    <div class="mytask-header__left">
      <div class="mytask-header__icon-wrap">
        <i class="pi pi-check-square"></i>
      </div>
      <div>
        <h1 class="mytask-title">My Tasks</h1>
        <p class="mytask-subtitle">Track and manage your workflow cases.</p>
      </div>
    </div>
    <div class="mytask-header__right">
      <span class="mytask-search-wrap">
        <i class="pi pi-search"></i>
        <input pInputText [(ngModel)]="searchTerm" placeholder="Search tasks…" class="mytask-search-input" />
      </span>
      <button class="mytask-btn-refresh" (click)="loadMyTasks()" [disabled]="loading">
        <i class="pi pi-refresh" [class.pi-spin]="loading"></i>
        Refresh
      </button>
    </div>
  </div>

  <!-- ── KPI Strip ───────────────────────────────── -->
  <div class="mytask-kpi-strip">
    <div class="mytask-kpi-card mytask-kpi-card--total">
      <div class="mytask-kpi-card__icon"><i class="pi pi-list-check"></i></div>
      <div>
        <div class="mytask-kpi-card__val">{{ totalCount }}</div>
        <div class="mytask-kpi-card__label">Total</div>
      </div>
    </div>
    <div class="mytask-kpi-card mytask-kpi-card--pending">
      <div class="mytask-kpi-card__icon"><i class="pi pi-inbox"></i></div>
      <div>
        <div class="mytask-kpi-card__val">{{ pending.length }}</div>
        <div class="mytask-kpi-card__label">Pending</div>
      </div>
    </div>
    <div class="mytask-kpi-card mytask-kpi-card--progress">
      <div class="mytask-kpi-card__icon"><i class="pi pi-spinner"></i></div>
      <div>
        <div class="mytask-kpi-card__val">{{ inProgress.length }}</div>
        <div class="mytask-kpi-card__label">In Progress</div>
      </div>
    </div>
    <div class="mytask-kpi-card mytask-kpi-card--done">
      <div class="mytask-kpi-card__icon"><i class="pi pi-check-circle"></i></div>
      <div>
        <div class="mytask-kpi-card__val">{{ completed.length }}</div>
        <div class="mytask-kpi-card__label">Completed</div>
      </div>
    </div>
  </div>

  <!-- ── Loading ────────────────────────────────── -->
  <div class="mytask-loading" *ngIf="loading">
    <p-progressSpinner strokeWidth="3" styleClass="mytask-spinner"></p-progressSpinner>
    <span>Loading tasks…</span>
  </div>

  <!-- ── Error ──────────────────────────────────── -->
  <div class="mytask-error" *ngIf="!loading && loadError">
    <i class="pi pi-exclamation-circle"></i>
    <span>Failed to load tasks.</span>
    <button class="mytask-btn-refresh" (click)="loadMyTasks()">Retry</button>
  </div>

  <!-- ── Board ──────────────────────────────────── -->
  <div class="mytask-board" *ngIf="!loading && !loadError">

    <!-- PENDING -->
    <div class="mytask-board-col mytask-board-col--pending">
      <div class="mytask-board-col__header">
        <div class="mytask-board-col__header-left">
          <span class="mytask-board-col__dot"></span>
          <span class="mytask-board-col__title">Pending</span>
        </div>
        <span class="mytask-board-col__count">{{ filteredPending.length }}</span>
      </div>
      <div class="mytask-board-col__body">
        <ng-container *ngFor="let card of filteredPending">
          <ng-container *ngTemplateOutlet="taskCard; context: { $implicit: card, board: 'pending' }"></ng-container>
        </ng-container>
        <div class="mytask-board-empty" *ngIf="filteredPending.length === 0">
          <i class="pi pi-inbox"></i><span>Nothing here</span>
        </div>
      </div>
    </div>

    <!-- IN PROGRESS -->
    <div class="mytask-board-col mytask-board-col--progress">
      <div class="mytask-board-col__header">
        <div class="mytask-board-col__header-left">
          <span class="mytask-board-col__dot"></span>
          <span class="mytask-board-col__title">In Progress</span>
        </div>
        <span class="mytask-board-col__count">{{ filteredInProgress.length }}</span>
      </div>
      <div class="mytask-board-col__body">
        <ng-container *ngFor="let card of filteredInProgress">
          <ng-container *ngTemplateOutlet="taskCard; context: { $implicit: card, board: 'progress' }"></ng-container>
        </ng-container>
        <div class="mytask-board-empty" *ngIf="filteredInProgress.length === 0">
          <i class="pi pi-inbox"></i><span>Nothing here</span>
        </div>
      </div>
    </div>

    <!-- COMPLETED -->
    <div class="mytask-board-col mytask-board-col--completed">
      <div class="mytask-board-col__header">
        <div class="mytask-board-col__header-left">
          <span class="mytask-board-col__dot"></span>
          <span class="mytask-board-col__title">Completed</span>
        </div>
        <span class="mytask-board-col__count">{{ filteredCompleted.length }}</span>
      </div>
      <div class="mytask-board-col__body">
        <ng-container *ngFor="let card of filteredCompleted">
          <ng-container *ngTemplateOutlet="taskCard; context: { $implicit: card, board: 'completed' }"></ng-container>
        </ng-container>
        <div class="mytask-board-empty" *ngIf="filteredCompleted.length === 0">
          <i class="pi pi-inbox"></i><span>Nothing here</span>
        </div>
      </div>
    </div>

  </div>

</div>

<!-- ── Task Card Template ──────────────────────── -->
<ng-template #taskCard let-card let-board="board">
  <div class="mytask-card" [class.mytask-card--done]="board === 'completed'" (click)="openCase(card)" style="cursor:pointer">

    <div class="mytask-card__top">
      <span class="mytask-card__workflow">
        <i class="pi pi-sitemap"></i>
        {{ card.workflowName }}
      </span>
      <span class="mytask-card__status-badge"
        [class.badge--pending]="board === 'pending'"
        [class.badge--progress]="board === 'progress'"
        [class.badge--done]="board === 'completed'">
        {{ board === 'pending' ? 'Pending' : board === 'progress' ? 'In Progress' : 'Completed' }}
      </span>
    </div>

    <div class="mytask-card__case-id">
      <i class="pi pi-hashtag"></i> {{ card.caseId }}
    </div>

    <div class="mytask-card__progress-wrap">
      <div class="mytask-card__progress-bar">
        <div class="mytask-card__progress-fill"
          [style.width.%]="progressPercent(card)"
          [class.fill--done]="board === 'completed'">
        </div>
      </div>
      <span class="mytask-card__progress-label">
        {{ card.completedTasks }} / {{ card.totalTasks }} tasks
      </span>
    </div>

    <div class="mytask-card__footer">
      <span class="mytask-card__date">
        <i class="pi pi-calendar"></i>
        {{ card.createdAt | appDate:'date' }}
      </span>
      <span class="mytask-card__pct">{{ progressPercent(card) }}%</span>
    </div>

  </div>
</ng-template>
